<template>
  <v-list>
    <IdNameForm :userData="userData" />
    <DoctorForm v-if="userData.userType === 'DOCTOR'" :userData="userData"/>
    <PharmacistForm v-if="userData.userType === 'PHARMACIST'" :userData="userData" />
    <EtcInfoForm :userData="userData" />
    <PasswordForm v-if="!isAuthorized" :userData="userData" />

  </v-list>
</template>
<script>
import { mapGetters } from "vuex";
import IdNameForm from "./comp/IdNameForm.vue";
import DoctorForm from "./comp/DoctorForm.vue";
import PharmacistForm from "./comp/PharmacistForm.vue";
import EtcInfoForm from "./comp/EtcInfoForm.vue";
import PasswordForm from "./comp/PasswordForm.vue";


export default {
  components: { IdNameForm,  DoctorForm, PharmacistForm, EtcInfoForm, PasswordForm},
  props: {
    userData: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(["isAuthorized"]),
  },
};
</script>
